import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import classnames from 'classnames';
import s from './RowWrapper.scss';
const RowWrapper = /*#__PURE__*/ React.forwardRef((_param, innerRef)=>{
    var { className  } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _extends({
        ref: innerRef,
        className: classnames(s['strip'], className)
    }, props));
});
RowWrapper.displayName = 'RowWrapper';
export default RowWrapper;
